export default __webpack_public_path__ + "static/101-34db0f43eea5c4426fed0c3fa85524f7.jpg";